import styled, { css } from 'styled-components';
import Image from 'next/image';
import { CustomLink } from '../../CustomLink';
import { Typography } from '../../ui/Typography';
import {
  ellipsisText,
  FlexibleDiv,
  multilineEllipsis
} from '../../../styled/common';
import { Breakpoints } from '../../../styled/constants';
import {
  animation,
  PlaceholderBlock
} from '../../../styled/placeholders.styled';

export const StyledAgencyCard = styled(CustomLink)`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 15px;
  box-shadow: 0 0 3px 0 rgba(255, 255, 255, 0.84);
  box-sizing: border-box;
  background-color: ${({ theme: { colors } }) => colors.background.tertiary};
  text-decoration: none;
  width: 100%;
  border-radius: 21px;

  span {
    margin-top: 5px;
  }

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    padding: 20px;
    width: calc(50% - 7.5px);

    span {
      margin-top: 9px;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    width: calc(25% - 15px);
  }
`;

export const Row = styled(FlexibleDiv)`
  padding: 0 75px;

  > div,
  h2 {
    ${ellipsisText}
  }

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    padding: 0;
    gap: 34px;
  }
`;

export const Description = styled(Typography)`
  padding: 0 75px;
  ${multilineEllipsis({ lineHeight: '1.2' })};

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    padding: 0;
    ${multilineEllipsis({ linesToShow: 3, lineHeight: '1.2' })};
  }
`;

export const AgencyLogo = styled(Image)`
  height: 55px;
  width: 55px;
  border-radius: 50%;
  position: absolute;
  top: calc((100% - 55px) / 2);
  left: 15px;
  ${animation};

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    position: static;
  }
`;

const phoneContainerStyles = css`
  position: absolute;
  top: calc((100% - 55px) / 2);
  right: 15px;
`;

export const PhoneButtonContainer = styled.div`
  ${phoneContainerStyles};

  svg {
    width: 55px;
    height: 55px;
  }
`;

export const PhonePlaceholder = styled(PlaceholderBlock)`
  ${phoneContainerStyles};

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    display: none;
  }
`;

export const Title = styled(Typography).attrs({ tag: 'h2', $lineToShow: 1 })`
  margin: 0;
`;

export const OffersCount = styled(Typography).attrs({ tag: 'title_2' })`
  color: ${({ theme: { colors } }) => colors.text.secondary};
  display: block;

  ${ellipsisText};
`;
